<template>
    <div>
      <div class="uk-grid-small" uk-grid>
        <div class="uk-width-1-1">
          <h3>{{ item.product_name + ' ' + item.upc }}</h3>
        </div>
        <div class="uk-width-1-1">
          <div class="uk-grid-small" uk-grid>
            <div class="uk-width-1-1@s uk-width-1-1@m uk-width-1-2@l uk-width-1-2@l">
              <form class="uk-form-horizontal" v-on:submit.prevent="updateItem">
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="upc" class="uk-form-label">UPC</label>
                    <div class="uk-form-controls">
                      <input id="upc" type="text" class="uk-input" v-model="item.upc" placeholder="Enter the UPC" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="sku" class="uk-form-label">SKU</label>
                    <div class="uk-form-controls">
                      <input id="sku" type="text" class="uk-input" v-model="item.sku" placeholder="Enter the SKU" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="price" class="uk-form-label">Price</label>
                    <div class="uk-form-controls">
                      <input id="price" type="text" class="uk-input" v-model="item.new_price" @change="setPrice" placeholder="Enter the price" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <button class="uk-button uk-button-primary">Save</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "Show",
    data() {
      return {
        item: {
          id: null,
          product_id: null,
          product_name: null,
          upc: null,
          sku: null,
          metadata: null,
          price: null,
          new_price: null,
          created_at: null,
          updated_at: null
        }
      }
    },
    activated() {
      this.getItem();
    },
    mounted() {
      this.getItem();
    },
    methods: {
      setPrice() {
        const self = this;
        self.item.new_price = parseFloat(self.item.new_price);
      },
      async getItem() {
        const self = this;

        self.$request().get(`/item/${self.$route.params.id}`)
          .then(r => {
            r = self.$request().successHandler(r).data;

            self.item.id = r.id;
            self.item.product_id = r.product_id;
            self.item.product_name = r.product_name;
            self.item.upc = r.upc;
            self.item.sku = r.sku;
            self.item.new_price = r.price;
            self.item.price = r.price;
            self.item.metadata = r.metadata;
            self.item.created_at = r.created_at;
            self.item.updated_at = r.updated_at;

          }).catch(r => {
            self.$router.push({name: 'PageNotFound'})
          });
      },
      async updateItem() {
        const self = this;

        self.$request().put(`/item/${self.item.id}`, {
          product_id: self.item.product_id,
          upc: self.item.upc,
          sku: self.item.sku,
          metadata: self.item.metadata
        }).then(r => {
          self.$request().post(`/item/${self.item.id}/price`, {
            value: self.item.new_price
          });
          
          self.$uikit().notification({
            message: 'The update was successfully completed.',
            status: 'success',
            position: 'top-center',
            timeout: 5000,
          });

          setTimeout(function(){
            self.$router.back();
          }, 2500);
        }).catch(e => {
          self.$uikit().notification({
            message: 'Something went wrong! Please try again later',
            status: 'warning',
            position: 'top-right',
            timeout: 5000,
          });
        });
      },
      async createPrice() {

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/item/Show.vue